/**
 * Elegir el color de un profesional (015 · FR-020).
 *
 * La paleta es la misma que reparte el servidor. El input nativo deja
 * salir de esos doce: el borde solo admite `#rrggbb`.
 */
import { PALETA_HORARIOS, normalizarHex } from '../../lib/horarios-colores'

export function PaletaColor({
    actual,
    nombre,
    onElegir,
    disabled,
}: {
    actual: string
    nombre: string
    onElegir: (color: string) => void
    disabled?: boolean
}) {
    const actualNorm = normalizarHex(actual) ?? actual.toLowerCase()

    function elegir(v: string) {
        const hex = normalizarHex(v)
        if (hex) onElegir(hex)
    }

    return (
        <div
            className="flex flex-wrap items-center gap-1.5"
            data-testid="paleta-color"
            role="group"
            aria-label={`Color de ${nombre}`}
        >
            {PALETA_HORARIOS.map((c) => {
                const on = c === actualNorm
                return (
                    <button
                        key={c}
                        type="button"
                        aria-label={c}
                        aria-pressed={on}
                        data-testid={`color-swatch-${c}`}
                        disabled={disabled}
                        onClick={() => elegir(c)}
                        className={
                            'h-7 w-7 shrink-0 rounded-full border md:h-5 md:w-5 ' +
                            (on ? 'border-white ring-2 ring-white/50' : 'border-neutral-700')
                        }
                        style={{ background: c }}
                    />
                )
            })}
            <label
                className="relative h-7 w-7 shrink-0 overflow-hidden rounded-full border border-neutral-600 md:h-5 md:w-5"
                title="Otro color"
            >
                <span className="sr-only">Otro color</span>
                <input
                    type="color"
                    value={actualNorm.startsWith('#') ? actualNorm : '#38bdf8'}
                    disabled={disabled}
                    onChange={(e) => elegir(e.target.value)}
                    className="absolute inset-0 cursor-pointer opacity-0"
                />
                <span
                    aria-hidden
                    className="block h-full w-full"
                    style={{
                        background: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
                    }}
                />
            </label>
        </div>
    )
}
